const syncPublicRouter = [
  {
    path: "/",
    hidden: true,
    component: () => import("@/views/layout/layout"),
    redirect: { path: "/signMountApp/login" }
  },
  {
    path: "/login",
    hidden: true,
    component: () => import("@/views/layout/layout"),
    redirect: (to) => {
      return {
        path: "/signMountApp/login",
        query: {
          ...to.query
        }
      };
    },
    meta: {
      onWhiteList: true
    }
  },
  {
    path: "/subapp/", // 产品服务-微服务
    name: "subapp",
    hidden: true,
    component: () => import("@/views/layout/serviceSubviewLayout"),
    children: [
      {
        path: "/subview/*",
        name: "subview",
        hidden: true,
        component: () => import("@/views/public/subview/serviceMountApp/index"),
        meta: { title: "加载中...", hiddenSidebar: true }
      },
      {
        path: "/serviceRedirect",
        name: "serviceRedirect",
        hidden: true,
        component: () => import("@/views/public/subview/serviceMountApp/redirect"),
        meta: { title: "加载中...", hiddenSidebar: true }
      },
      {
        path: "/home",
        component: () => import("@/views/public/dashboard/index.vue"),
        name: "home",
        meta: {
          title: "home"
        }
      }
    ]
  },
  {
    path: "/serviceSimpleLayout", // 产品服务-老服务兼容
    name: "serviceSimpleLayout",
    hidden: true,
    component: () => import("@/views/layout/simpleLayout"),
    children: [
      {
        path: "/serviceweb",
        name: "serviceweb",
        hidden: true,
        component: () => import("@/views/public/serviceweb/index"),
        meta: { title: "我的服务" }
      }
    ]
  },
  {
    path: "/signMountAppLayout/", // 登录微服务
    name: "signMountAppLayout",
    hidden: true,
    component: () => import("@/views/public/subview/signMountApp/layout"),
    children: [
      {
        path: "/signMountApp/*",
        name: "signMountApp",
        hidden: true,
        component: () => import("@/views/public/subview/signMountApp/index"),
        meta: { title: "加载中..." }
      }
    ]
  }
];

export default syncPublicRouter;



// WEBPACK FOOTER //
// ./src/router/sync_router/public.js